import * as React from "react";
import OutOfNetworkStepper from "@app/preBill/components/outOfNetworkStepper";

const OutOfNetworkPage: React.FC = () => {
  return <OutOfNetworkStepper />;
};

export default OutOfNetworkPage;
